import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { PasswordResetService } from 'src/app/_services/password-reset.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../login/login.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: UntypedFormGroup;
  isSubmitting: boolean = false;
  resultMessageClass: string = "";
  resultMessage: string = "";

  constructor(
    private titleService: Title,
    private fb: UntypedFormBuilder,
    private passwordResetService: PasswordResetService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      if (params['app']) {
        if (params['app'] == "productioneer") {
          let btn = document.getElementById("BackToLoginBtn")
          btn.hidden = true;
        }
      }
    });
    this.titleService.setTitle('Forgot Password - Productioneer Portal');
    this.forgotPasswordForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]]
    })
  }

  onPasswordResetLinkRequest() {
    this.isSubmitting = true;
    this.passwordResetService.requestPasswordResetLink(this.forgotPasswordForm.value.email).subscribe(
      data => {
        this.isSubmitting = false;
        this.resultMessageClass = "alert alert-success";
        this.resultMessage = "Instructions for resetting your password were sent to " + this.forgotPasswordForm.value.email;
      },
      err => {
        console.log(err);
        this.isSubmitting = false;
        this.resultMessageClass = "alert alert-danger";
        if (err.status == 400 && err.error) {
          this.resultMessage = err.error;
        }
        else {
          this.resultMessage = err.error || "We were unable to reset your password. Please try again or contact support@mi4.com.";
        }
      });
  }
}
